import { z } from "zod";

const clientAppointmentUpcomingItemSchema = z.object({
  id: z.number(),
  notes: z.string().max(1000, "Notes must be 1000 characters or less"),
});

export const clientAppointmentUpcomingSchema = z.object({
  items: z.array(clientAppointmentUpcomingItemSchema),
});

export type ClientAppointmentUpcomingFormValues = z.infer<
  typeof clientAppointmentUpcomingSchema
>;
